module.exports = __webpack_public_path__ + "img/kuang_bg.908d7c4a.png";